<template>
  <section style="background-color: #eee">
    <div class="card" id="chat1">
      <div class="card-header d-flex justify-content-between align-items-center p-3 bg-primary text-white border-0">
        <i class=""></i>
        <p class="mb-0 fw-bold">گفتگو زنده</p>
        <i class=""></i>
      </div>
      <div class="card-body">
        <div style="max-height: 400px; overflow-y: auto" class="scrollDown">
          <p v-if="!messages.length" class="fw-bold min-height='100'">
            پیامی وجود ندارد!
          </p>
          <div v-for="message in messages" :key="message.createdAt" class="d-flex flex-row mb-4"
            :class="message.username === currentUserPersonalInfo.cellphone ? 'justify-content-start' : 'justify-content-end'">
            <div v-if="message.username === currentUserPersonalInfo.cellphone"
    >
              <div class="d-flex  flex-row justify-content-start">
                <p class="small mb-4">شما</p>
              </div>
              <div class="d-flex flex-row justify-content-start">
                <div>
                  <p class="small p-2 me-3 mb-3 rounded text-white bg-info text-wrap" style="
                      background-color: rgba(57, 192, 237, 0.2);
                      overflow-wrap: anywhere;
                    ">
                    {{ message.text }}
                  </p>
                </div>
              </div>
            </div>
            <div v-if="message.username !== currentUserPersonalInfo.cellphone">
              <div class="d-flex justify-content-between">
                <p class="small mb-1">
                  {{ gFullName(message) }}
                </p>
              </div>
              <div class="d-flex flex-row justify-content-start">
                <div>
                  <p class="small p-2 ms-3 mb-3 rounded bg-primary text-white" style="overflow-wrap: anywhere">
                    {{ message.text }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer text-muted d-flex justify-content-start align-items-center p-3">
          <input type="text" class="form-control form-control-lg" id="exampleFormControlInput1" :placeholder="
            !currentUserPersonalInfo.id
              ? 'برای ارسال پیام ابتدا وارد پنل میرول شوید !'
              : 'تایپ کنید...'
          " v-model="text" :disabled="!currentUserPersonalInfo.id" @keyup.enter="sendMessage" />
          <a class="ms-3" @click="sendMessage" v-if="text">
            <i class="fas fa-paper-plane ml-2 text-primary"></i></a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { io } from "socket.io-client";
import axios from "axios";

export default {
  name: "chat",
  components: {
  },
  data() {
    return {
      messages: [],
      socket: io("https://chat.mirol.ir"),
      text: "",
      loaded: false
    };
  },
  mounted() {
    const slug = this.$route.params.slug;
    axios.get(`https://chat.mirol.ir/messages/${slug}`).then((res) => {
      this.messages = [...this.messages, ...res.data.messages];
    });
    this.socket.emit("join", this.form);
    this.socket.on("message", (message) => {
      this.messages.push(message);
    });
  },
  beforeDestroy() {
    this.socket.on("disconnect");
  },
  computed: {
    ...mapGetters([
      "currentUserPersonalInfo"
    ]),
    form() {
      let data = {}
      data.username = this.currentUserPersonalInfo.cellphone
      data.room = this.$route.params.slug
      data.first_name = this.currentUserPersonalInfo.first_name
      data.last_name = this.currentUserPersonalInfo.last_name
      return data
    }
  },
  methods: {
    sendMessage() {
      if (this.text) {
        this.socket.emit("sendMessage", this.text);
        this.text = "";
        this.scrollDown();
      }
    },
    scrollDown() {
      let element = document.querySelector(".scrollDown");
      element.scrollTop = element.scrollHeight - element.getBoundingClientRect().height;
    }
  }
};
</script>

